<template>
    <div class="border-color1 oldInfoBox">
        <div class="headline">Freunde einladen</div>
        <div>Kennst du jemanden der auch mitmachen möchte?</div>
        
        <div class="errorBox" v-if="error">{{errorText}}</div>
        <div v-if="success" class="errorText">Einladung gesendet</div>
        
        <div style="margin:5px 0 15px 0">
            <p class="font075" style="margin-bottom: 0px;">E-Mail-Adresse</p>
            <input v-model="email" type="text" name="invitationEmail" id="invitationEmail">
        </div>
        
        <div style="margin:5px 0 15px 0">
            <textarea v-model="text" type="text" name="invitationText" id="invitationText" placeholder="Dein persönlicher Einladungstext" rows="5" />
        </div>
        
        <button type="button" :disabled="isDisabled" class="btn btn-blue btn-block btn-lg btn-lg-reset-font-size text-uppercase text-letter-spacing2 white-space-normal" @click="sendInvitation">
            <span>Einladung senden</span>
        </button>
    </div>
</template>

<script>
	export default {
		name: 'profileInvitation',
		props: {
            
        },
         data: function() {
        	return {
                email: '',
                text: '',
                error: false,
                success: false,
                errorText: '',
                defaultErrorText: 'Einladung konnte nicht versendet werden'
        	}
        },
        computed: {
        	isDisabled() {
        		 if(this.email.trim().length > 0 && this.text.trim().length > 0) {
        			 return false;
        		 }
        		 return true;
        	}
        },
        methods: {
        	sendInvitationSuccess: function(data) {
        		this.success = true;
        		this.email = '';
        		this.text = '';
        	},
        	sendInvitationError: function(e) {
        		this.error = true;
        		if(e.responseText) {
        			this.errorText = e.responseText;
        		}else {
        			this.errorText = this.defaultErrorText;
        		}
                console.log("error while sending invitation - " + e.responseText);
            },
        	sendInvitation: function() {
        		this.error = false;
        		this.success = false;
        		var invitation = {};
        		invitation.email = this.email;
        		invitation.text = this.text;
            	jQuery.ajax ({
                    url: '/sendInvitation/',
                    type: 'POST',
                    dataType: "json",
                    data: JSON.stringify(invitation),
                    contentType: "application/json; charset=utf-8",
                    success: this.sendInvitationSuccess,
                    error: this.sendInvitationError
                });
            }
        }
	}
</script>


// WEBPACK FOOTER //
// ProfileInvitation.vue?5771db2b